import React from "react";

const BatteryIndicator = ({ percentage, remainingTime }) => {
  // Ensure that the percentage is within 0 to 100 range
  const validPercentage = Math.min(100, Math.max(0, percentage));

  // Calculate hours and minutes from remainingTime
  const hours = Math.floor(remainingTime / 60); // Get full hours
  const minutes = remainingTime % 60; // Get remaining minutes

  // Determine the level class based on the percentage
  let levelClass = "full"; // Default to full (you can customize this logic)
  if (validPercentage < 10) {
    levelClass = "low"; // Less than 10% -> red
  } else if (validPercentage < 50) {
    levelClass = "medium"; // Between 10% and 50% -> yellow
  } else if (validPercentage < 100) {
    levelClass = "high"; // Between 50% and 100% -> green
  }

  // Format remaining time for display
  const formattedTime = `${hours} ชั่วโมง ${minutes} นาที`;

  return (
    <div className="battery-indicator-container">
      <div className="battery-header">แบตเตอรี่</div>
      <div className="battery-body">
        <div
          className={`battery-level ${levelClass}`}
          style={{ width: `${Math.max(10, validPercentage)}%` }}
        >
          <span>{validPercentage}%</span>
        </div>
      </div>
      <div className="battery-footer">เวลาคงเหลือ</div>
      <div className="battery-footer">
        <span> {formattedTime}</span>
      </div>
    </div>
  );
};

export default BatteryIndicator;
